import axios, {AxiosPromise} from "axios";

declare global {
    interface Window {
        submitDemoForm: () => void;
    }
}

type SubscribeResponse = { success: boolean }

const subscribeToNewsletterRequest = (email: string): AxiosPromise<SubscribeResponse> => {
    const data = new FormData();
    data.set('action', codepress.form_newsletter_request.action);
    data.set('nonce', codepress.form_newsletter_request.nonce);
    data.set('email', email);
    data.set('origin', 'demo-signup');

    return axios.post(window.location.href, data)
}


export const initDemoForm = (form: HTMLFormElement) => {
    window.submitDemoForm = () => {
        form.dispatchEvent(new Event('submit'));
    }

    form.addEventListener('submit', (event) => {
        event.preventDefault();

        if (!form.checkValidity()) {
            form.reportValidity();
            return;
        }

        const data = new FormData(form)
        const encodedEmail = encodeURIComponent(data.get('email') as string);
        const magicLink = `https://app.instawp.io/launch?t=demo-admin-columns-pro&d=v2&email=${encodedEmail}`;

        subscribeToNewsletterRequest(data.get('email') as string).then(() => {
            window.location.href = magicLink;
        })
    });

}


